export default "__VITE_ASSET__750fecc8__"